import { Response, ResponseOptions } from "@angular/http";
import { ChangeQItem } from "../../../core/services/sync-up/internal";
import { SyncUpItem } from "./sync-up-item.model";

export class SyncUpItemFactory {

    static rehydrate(data: SyncUpItem): object {
        return new SyncUpItem({
            ...data,
            changeQItem: new ChangeQItem(data.changeQItem),
            response: data.response ? new Response(new ResponseOptions({
                body: data.response["body"] || data.response["_body"],
                url: data.response.url,
                status: data.response.status,
                statusText: data.response.statusText,
                headers: data.response.headers,
                type: data.response.type
            })) : undefined
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/sync-up-item/sync-up-item.factory.ts